import { Injectable } from '@angular/core';

@Injectable()
export class PreserveRouteService {
  public lastVisitedRoute: string;

  constructor() {}
}
